export default __webpack_public_path__ + "static/media/darbe.bb226a77.svg";